import React, { useMemo } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { buildBreadcrumb } from "../router/breadcrumbs";
import { ROUTE_META, PATHS } from "../router/paths";

const NavTree = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const breadcrumbItems = useMemo(() => {
    const items = buildBreadcrumb(location.pathname, ROUTE_META);

    if (
      location.pathname === PATHS.ORDERS.EDIT &&
      searchParams.get("copy") === "true"
    ) {
      items[items.length - 1] = {
        ...items[items.length - 1],
        title: "注文コピー",
      };
    }

    if (
      location.pathname === PATHS.PROPOSES.ROOT &&
      searchParams.get("representative_id")
    ) {
      items.push({
        path: `${PATHS.PROPOSES.ROOT}?representative_id=${searchParams.get("representative_id")}`,
        title: "提案書一覧",
      });
    }

    return items;
  }, [location.pathname, searchParams]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      {breadcrumbItems.map((item, index) => {
        const isLast = index === breadcrumbItems.length - 1;

        return (
          <React.Fragment key={item.path}>
            {index > 0 && (
              <span
                style={{
                  color: "#999",
                }}
              >
                &gt;&gt;
              </span>
            )}

            {isLast ? (
              <span>{item.title}</span>
            ) : (
              <Link
                to={item.path}
                style={{
                  color: "#1677ff",
                }}
              >
                {item.title}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default NavTree;
